import React from "react";
import PropTypes from "prop-types";
import {t} from "i18next";

/**
 * Plus More implementation specific to the Entity List.
 * Will render a PlusMoreTag component by default.
 * `customRenderer` can be used to override the default view.
 */
const PlusMore = ({customRenderer, remaining, handleClick, className}) =>
  customRenderer ? (
    customRenderer({remaining, handleClick})
  ) : (
    <a
      data-testid={"EntityListItem-PlusMoreBtn"}
      className={className}
      onClick={handleClick}>
      {t("misc.plusMore", {count: remaining})}
    </a>
  );

PlusMore.propTypes = {
  /**
   * Customize the appearance of this component.
   * If undefined, a PlusMoreTag will render by default.
   * The value of `remaining` and `handleClick` will be passed though to
   * the customRenderer, if it is defined.
   */
  customRenderer: PropTypes.func,
  /**
   * # of Remaining (hidden) list entities.
   */
  remaining: PropTypes.number,
  /**
   * Callback handler to fire when PlusMore or customerRenderer is clicked.
   */
  handleClick: PropTypes.func
};

export default PlusMore;
